import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const Delete = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"          ,} )
  })
)

export default Delete
